var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery3Medium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 149,
    viewBox: "0 0 142 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6458 68.3132C11.6877 58.829 17.3776 40.9529 32.3546 28.3857C47.3316 15.8185 65.9241 13.3192 73.8823 22.8034L125.304 84.0857C133.262 93.5699 127.573 111.446 112.596 124.013C97.6185 136.58 79.026 139.08 71.0678 129.596L19.6458 68.3132Z",
    fill: "#245F9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6828 67.6821C8.24958 57.6318 14.1933 38.7605 29.9586 25.5318C45.7238 12.3032 65.3406 9.72674 73.7738 19.7771L122.278 77.5817C130.711 87.6321 124.767 106.503 109.002 119.732C93.2367 132.961 73.6199 135.537 65.1867 125.487L16.6828 67.6821Z",
    fill: "#D5DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2525 95.9077C29.1934 82.7279 36.2106 65.176 51.9515 51.9678C67.6924 38.7596 86.1962 34.8969 97.2553 48.0766L107.84 60.6904L118.424 73.3041C132.928 84.8011 125.688 107.876 109.947 121.084C94.2058 134.292 71.8914 137.231 61.4209 121.135L40.2525 95.9077Z",
    fill: "#F09202"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M94.6561 44.7992C102.452 54.0895 95.9907 72.3446 80.2255 85.5732C64.4602 98.8018 45.3605 101.995 37.5651 92.7043C29.7696 83.414 36.2305 65.1589 51.9957 51.9303C67.761 38.7017 86.8607 35.509 94.6561 44.7992Z",
    fill: "#F0C01A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5918 67.49L76.4923 73.4472C74.636 75.0048 71.8047 74.3505 70.8201 72.1364L64.7932 58.5843C63.7374 56.2103 60.1761 57.0766 60.329 59.6705L62.5924 98.0588C62.7717 101.1 66.3397 102.637 68.6732 100.679L75.7727 94.7221C77.629 93.1645 80.4603 93.8188 81.4449 96.0329L87.4718 109.585C88.5276 111.959 92.0889 111.093 91.936 108.499L89.6725 70.1103C89.4931 67.0697 85.9251 65.5321 83.5918 67.49Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5907 67.4922L78.0392 72.1505C80.0493 81.4036 76.99 91.4324 69.2325 97.9417C67.7506 99.1852 66.1713 100.236 64.5257 101.1C65.7798 101.775 67.4069 101.743 68.6721 100.681L75.7715 94.7243C77.6279 93.1666 80.4592 93.821 81.4437 96.0351L87.4707 109.587C88.5265 111.961 92.0878 111.095 91.9349 108.501L89.6715 70.1123C89.492 67.0719 85.924 65.5343 83.5907 67.4922Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.0285,
    cy: 38.7252,
    rx: 33.5372,
    ry: 17.2218,
    transform: "rotate(-40 41.0285 38.7252)",
    fill: "#245F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7492,
    cy: 31.2421,
    rx: 18.6318,
    ry: 9.31588,
    transform: "rotate(-40 34.7492 31.2421)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery3Medium);
export default __webpack_public_path__ + "static/media/battery-3-medium.ddff6d5c790acfa07ab9bab559dfece3.svg";
export { ForwardRef as ReactComponent };